module.exports = __webpack_public_path__ + "assets/14a66c90c79c45453e4763ac934d5844.png";